
import ProductFunctions from '~/mixins/ProductFunctions'

export default {
  mixins: [ProductFunctions],
  props: {
    data: {
      type: Object,
      required: true,
    },

    bgWhite: {
      type: Boolean,
      default: false,
    },

    showProductType: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hovered: false,
    }
  },

  computed: {
    authorList() {
      if (!Array.isArray(this.data.authors) || !this.data.authors.length) {
        return ''
      }

      return this.data.authors.map((author) => author.title).join(', ')
    },

    canOnlyBeBoughtExternally() {
      return ['E-Book', 'App'].includes(this.data.product_type)
    },

    canBeAddedToCart() {
      return this.data.buyable_in_shop && !this.canOnlyBeBoughtExternally
    },
  },
}
